<template>
  <div class="d-flex usersNotOnSite-loading-container">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <div class="usersNotOnSite-loader-content">
      <p>{{ loaderText }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "usersNotOnSiteLoader",
  props: ["loaderText"],
};
</script>
<style lang="scss" scoped>
.usersNotOnSite-loading-container {
  position: absolute;
  top: 300px;
  inset-inline-start: 50%;
  background-color: white;
  align-items: center;
  border-radius: 60.5px;
  width: 302px;
  height: 121px;

  h6 {
    font-weight: 700;
    font-size: 16px;
    line-height: 152%;
    color: #000000;
    margin-bottom: 20px;
  }
  p {
    margin-top: 5px;
    font-weight: 700;
    font-size: 16px;
    color: #000000;
    margin-bottom: 6px;
    line-height: 152%;
  }
  span.count {
    font-weight: 600;
    color: #787878;
    font-size: 14px;
    line-height: 152%;
  }
  .submit-btn {
    margin-inline-end: 0px;
  }
  .btn-text {
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    color: #ffffff;
  }
  p.reauthenticate {
    font-weight: 600;
    font-size: 14px;
    line-height: 152%;
    color: #787878;
    margin-bottom: 20px;
  }
}
.spinner-border {
  color: #103f5e;
  border-width: 0.35em;
  width: 38px;
  height: 38px;
  margin-inline-start: 33px;
  margin-inline-end: 21px !important;
  border-right-color: #d9d9d9;
}
</style>
